


























































import ErrorAlert from '@/components/common/ErrorAlert.vue';
import ALDialog from '@/components/core/Dialog/ALDialog.vue';
import draggable from '@/mixins/draggable';
import { Module } from '@/models/configurator/module';
import { ErrorManager } from '@/models/error';
import { compareOrder } from '@/utils/helpers';
import mixins from '@/utils/mixins';
import { cloneDeep } from 'lodash';
import { PropType } from 'vue';
import VueDraggable from 'vuedraggable';
import { mapActions } from 'vuex';

export default mixins(draggable).extend({
  name: 'ModuleOrderSetupDialog',

  components: {
    VueDraggable,
    ALDialog,
    ErrorAlert
  },

  props: {
    items: Array as PropType<any[]>
  },

  data() {
    return {
      dialog: false,
      loading: false,
      list: [] as Module[],
      errorMessage: '',
      detailErrorMessage: ''
    };
  },

  watch: {
    dialog(val: boolean) {
      if (val) {
        this.clearAllErrors();
        this.list = cloneDeep(this.items);
      }
    }
  },

  methods: {
    ...mapActions('configuratorModule', ['updateModuleOrder']),

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    async updateOrder() {
      this.clearAllErrors();
      const modules = this.list.map(function(module: Module, index: number) {
        module.order = index + 1;
        return module;
      });
      const difference: Module[] = modules.filter(compareOrder(this.items));

      if (difference.length) {
        this.loading = true;

        await Promise.all(
          difference.map(async item => {
            await this.updateModuleOrder({
              id: item.id,
              order: item.order
            }).catch(error => {
              if (error.response) {
                if (error.response.data.detail) {
                  this.detailErrorMessage = error.response.data.detail;
                }
              }
              this.errorMessage = ErrorManager.extractApiError(error);
            });
          })
        );
        this.loading = false;
      }
      this.close();
      this.$emit('orderChanged');
    },

    close() {
      this.dialog = false;
    }
  }
});
